import { Section } from "@react-email/components";
import { EmailButton } from "@/email/components/EmailButton";
import { EmailHeading } from "@/email/components/EmailHeading";
import { EmailText } from "@/email/components/EmailText";
import { EmailWrapper } from "@/email/components/EmailWrapper";
import { isOurTenant } from "@/store/tenant/selectors";
import { ITenant, ITenantFeature } from "@/types/tenant";
import { User } from "@/types/user";

interface DocumentAttachmentEmailProps {
    user: User;
    tenant: ITenant | null;
}

const DocumentAttachmentEmail = ({
    user,
    tenant,
}: DocumentAttachmentEmailProps) => {
    const is1TemplateTenant = isOurTenant(tenant);
    const intro = user?.firstName ? `Hey ${user?.firstName},` : "Hey,";
    const preview = is1TemplateTenant ? "Your 1Template " : "Your ";
    const craftedResume = is1TemplateTenant
        ? " crafted 1Template resume "
        : " crafted resume ";
    const tenantFeatures = tenant?.features;
    const isCreditsEnabled = tenantFeatures?.[ITenantFeature.CREDITS];
    return (
        <EmailWrapper
            preview={`${preview}Resume is attached!`}
            tenant={tenant}
        >
            <EmailHeading>Your Resume is Ready!</EmailHeading>
            <EmailText>{intro}</EmailText>
            <Section>
                <EmailText>
                    Your professionally{craftedResume}is attached and ready to
                    make an impact!
                </EmailText>
            </Section>
            {isCreditsEnabled && (
                <Section
                    style={{
                        marginTop: "16px",
                        padding: "16px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "8px",
                        border: "1px solid #e9ecef",
                    }}
                >
                    <EmailText
                        additionalStyle={{
                            fontWeight: "bold",
                            fontSize: "18px",
                            color: "#303330",
                        }}
                    >
                        Need more credits?
                    </EmailText>
                    <EmailText
                        additionalStyle={{
                            color: "#303330",
                            marginBottom: "16px",
                            fontSize: "16px",
                        }}
                    >
                        Get additional credits to keep your job search on track.
                    </EmailText>
                    <EmailButton
                        noMargin
                        href="https://www.1template.io/pricing?utm_source=email&utm_medium=email&utm_campaign=email_pdf_download"
                    >
                        See Packs
                    </EmailButton>
                </Section>
            )}
            {is1TemplateTenant && (
                <Section style={{ marginTop: "32px" }}>
                    <EmailText noMargin>Best regards,</EmailText>
                    <EmailText>The 1Template Team</EmailText>
                </Section>
            )}
        </EmailWrapper>
    );
};

export default DocumentAttachmentEmail;
